<script setup>
import {to} from "await-to-js";
import {computed, onMounted, reactive, ref} from "vue";
import {get, isArray, isEmpty, omitBy, set} from "lodash";
import {interceptor} from "@dutypay/utilities";
import {useEnvStore} from "@dutypay/store-modules";
import {ElNotification} from "element-plus";

const loading = ref(false);
const infrastructureCompoments = ref([]);
const apiRoutes = ref([]);
const lookupKeys = ref([]);

const methodList = [
  "GET", "POST", "PATCH", "PUT", "DELETE"
];

const permissions = ref([]);
const initializeGroups = (row) => {
  if (!Array.isArray(row.permission.requirement.values)) {
    //row.permission.requirement.ids = [];
    row.permission.requirement.values = [];
  }
};

// Not required anymore because row.permission.requirement.ids is deprecated
/*
const updatePermissionNames = (row, index) => {
  // Extract selected IDs
  const selectedIds = row.permission.requirement.ids[index];

  // Map IDs to corresponding names
  row.permission.requirement.values[index] = selectedIds.map(id => {
    const match = permissions.value.find(item => item.hs.permission.id === id);
    return match ? match.name : "";
  });
};*/


const addGroup = (row) => {
  if (!Array.isArray(row.permission.requirement.values)) {
    initializeGroups(row);
  }
  //row.permission.requirement.ids.push([]);
  row.permission.requirement.values.push([]);
};

const removeGroup = (row, index) => {
  //row.permission.requirement.ids.splice(index, 1);
  row.permission.requirement.values.splice(index, 1);
};



const queriedApiRouteCount = ref(0);
const totalApiRouteCount = ref(0);
const envStore = useEnvStore();

const pageSizeOptions = ref([
  {label: '10', value: '10'},
  {label: '25', value: '25'},
  {label: '50', value: '50'}
]);

const parameters = reactive({
  pageSize: pageSizeOptions.value[0].value,
  pageNumber: "1",
  searchRouteName: "",
  methodName: "",
  infrastructureComponentID: ""
});

async function updatePageSize(size) {
  parameters.pageSize = size;
  parameters.pageNumber = "1";
  await getApiRoutes()
}

// TODO: Needs an improvement about permission properties if refactoring is done
async function updateAPIRoutes(data) {
  loading.value = true;
  try {
    JSON.parse(data.model);
    const cleanEmptyArrays = (list) => {
      return Array.isArray(list) ? list.filter(arr => Array.isArray(arr) && arr.length > 0) : list;
    };

    /*
    data = set(data, 'permission.requirement.ids', isArray(get(data, 'permission.requirement.ids'))
        ? JSON.stringify(cleanEmptyArrays(get(data, 'permission.requirement.ids')))
        : get(data, 'permission.requirement.ids'));*/

    data = set(data, 'permission.requirement.values', isArray(get(data, 'permission.requirement.values'))
        ? JSON.stringify(cleanEmptyArrays(get(data, 'permission.requirement.values')))
        : get(data, 'permission.requirement.values'));

    let err, res;
    [err, res] = await to(
        interceptor.patch(`${envStore.apiUrls.dutypay}/api/v0/api-routes/${data.hs.api.route.id}`, data)
    );
    if (err) {
      ElNotification({
        title: "Error to update api-route",
        type: "error",
        message: err.message
      });
    } else {
      console.log("res", res.data)
      ElNotification({
        title: res.data.name,
        type: "success",
        message: res.data.message
      });
    }
    //data = set(data, 'permission.requirement.ids', isArray(get(data, 'permission.requirement.ids')) ? get(data, 'permission.requirement.ids') : JSON.parse(get(data, 'permission.requirement.ids')))
    data = set(data, 'permission.requirement.values', isArray(get(data, 'permission.requirement.values')) ? get(data, 'permission.requirement.values') : JSON.parse(get(data, 'permission.requirement.values')))
    loading.value = false;
  } catch (err) {
    ElNotification({
      title: "JSON in model is invalid",
      type: "error",
      message: err.message
    });
    //data = set(data, 'permission.requirement.ids', isArray(get(data, 'permission.requirement.ids')) ? get(data, 'permission.requirement.ids') : JSON.parse(get(data, 'permission.requirement.ids')))
    data = set(data, 'permission.requirement.values', isArray(get(data, 'permission.requirement.values')) ? get(data, 'permission.requirement.values') : JSON.parse(get(data, 'permission.requirement.values')))
    loading.value = false;
  }
}

async function getPermissions() {
  loading.value = true;
  let err, res;
  [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay}/api/v0/permissions`, {
        params: {useNormalizedPermission: "true"}
      })
  );
  if (err) {
    loading.value = false;
    return;
  }
  permissions.value = [];
  permissions.value = res.data.result;
  loading.value = false;
}

const hasPreviousPage = computed(() => {
  return parseInt(parameters.pageNumber, 10) > 1;
});

async function getPreviousPage() {
  parameters.pageNumber = (parseInt(parameters.pageNumber, 10) - 1).toString();
  await getApiRoutes();
}

const hasNextPage = computed(() => {
  return (
      queriedApiRouteCount.value < totalApiRouteCount.value)
});

async function getNextPage() {
  parameters.pageNumber = (parseInt(parameters.pageNumber, 10) + 1).toString();
  await getApiRoutes();
}

async function getInfrastructureCompoments() {
  loading.value = true;
  let err, res;
  [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay}/api/v0/infrastructure-components`, {
        params: {type: 'api'}
      })
  );

  if (err) {

    if (err.response.data.name === "Not Found Error") {
      infrastructureCompoments.value = [];
    } else {
      loading.value = false;
      throw err;
    }
  } else {
    infrastructureCompoments.value = res.data.result;
  }
}

function getInfrastructureCompomentNameById(id) {
  let result = infrastructureCompoments.value.filter(function (row) {
    return row['hs.infrastructure.component.id'] === id
  });

  if (isEmpty(result[0])) {
    return "Unknown"
  }
  return result[0].name;
}

async function getLookupKeys(){

  loading.value = true;
  let err, res;

  [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay}/api/v0/api-routes/lookup-keys`)
  );

  if (err) {

    if (err.response.data.name === "Not Found Error") {
      lookupKeys.value = [];
    } else {
      loading.value = false;
      throw err;
    }
  } else {
    lookupKeys.value = res.data.result
  }

}

async function getApiRoutes() {
  loading.value = true;
  let err, res;
  const filteredParameters = omitBy(parameters, value => isEmpty(value));

  [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay}/api/v0/api-routes`, {
        params: filteredParameters,
      })
  );

  if (err) {

    if (err.response.data.name === "Not Found Error") {
      apiRoutes.value = [];
    } else {
      loading.value = false;
      throw err;
    }
  } else {
    apiRoutes.value = res.data.result.sqlQueriedAPIRouteList;
  }

  let updatedApiRoutes = []
  for (let apiRoute of apiRoutes.value) {
    apiRoute = set(apiRoute, 'infrastructure.component.name', getInfrastructureCompomentNameById(apiRoute.hs.infrastructure.component.id))
    apiRoute = set(apiRoute, 'JWT.isRequired', Boolean(apiRoute.JWT.isRequired))
    //apiRoute = set(apiRoute, 'permission.requirement.ids', isArray(get(apiRoute, 'permission.requirement.ids')) ? get(apiRoute, 'permission.requirement.ids') : JSON.parse(get(apiRoute, 'permission.requirement.ids')))
    apiRoute = set(apiRoute, 'permission.requirement.values', isArray(get(apiRoute, 'permission.requirement.values')) ? get(apiRoute, 'permission.requirement.values') : JSON.parse(get(apiRoute, 'permission.requirement.values')))
    apiRoute = set(apiRoute, 'headerAPIkey.isRequired', Boolean(apiRoute.headerAPIkey.isRequired))
    updatedApiRoutes.push(apiRoute)
  }
  apiRoutes.value = updatedApiRoutes;
  queriedApiRouteCount.value = res.data.result.sqlQueriedAPIRouteCurrentCount;
  totalApiRouteCount.value = res.data.result.sqlQueriedAPIRouteTotalCount;
  loading.value = false;
}

function checkForExistingGroup(data){
  return data.permission.requirement.values.length > 0
  }

onMounted(async () => {
  await getInfrastructureCompoments();
  await getPermissions();
  await getApiRoutes();
  await getLookupKeys();
});
</script>

<script>

import PaginationNavigationComponent from '../../components/PaginationNavigationComponent.vue';
import PaginationFilterOptionsRadioComponent from '../../components/PaginationFilterOptionsRadioComponent.vue';

export default {
  name: "ApiRoutesPage",
  components: {
    PaginationNavigationComponent,
    PaginationFilterOptionsRadioComponent
  },
};
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <h1>ApiRoutes</h1>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="16" :xl="16" :lg="16" :sm="32" :xs="32" class="searchform">
        <el-form-item style="padding-left: 1rem; flex-grow: 1">
          <el-input
              v-model="parameters.searchRouteName"
              @change="parameters.pageNumber = '1'"
              placeholder="Search for route.name"
              :clearable="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item style="padding-left: 1rem; flex-grow: 1">
          <el-select v-model="parameters.methodName" placeholder="Select method" :clearable="true">
            <el-option
                v-for="(item) in methodList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item style="padding-left: 1rem; flex-grow: 1">

          <el-select v-model="parameters.infrastructureComponentID" placeholder="Select Component" :clearable="true">
            <el-option
                v-for="(item) in infrastructureCompoments"
                :key="item.id"
                :label="item.name"
                :value="item['hs.infrastructure.component.id'] || 'undefined'"

            />
          </el-select>
        </el-form-item>
        <el-form-item style="padding-left: 1rem; flex-grow: 0">
          <el-button type="primary" @click="getApiRoutes"> Search</el-button>
        </el-form-item>
      </el-col>
      <el-col
          :span="8"
          :xl="8"
          :lg="8"
          :sm="24"
          :xs="24"
          class="pagesize"
          style="display: flex; justify-content: flex-end"
      >
        <pagination-filter-options-radio-component
            label="ApiRoutes per page"
            v-model="parameters.pageSize"
            :options="pageSizeOptions"
            :formItemStyle="'padding-top: 2px;'"
            :onChange="updatePageSize"
        ></pagination-filter-options-radio-component>
      </el-col>
    </el-row>
    <el-row>
      <pagination-navigation-component
          :leftIconClass="'el-icon--left'"
          :rightIconClass="'el-icon--right'"
          :previousLabel="'Previous'"
          :nextLabel="'Next'"
          :hasPrevious="hasPreviousPage"
          :hasNext="hasNextPage"
          :onPrevious="getPreviousPage"
          :onNext="getNextPage"
      ></pagination-navigation-component>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="apiRoutes" stripe style="width: 100%">
          <!--<el-table-column prop="hs.infrastructure.component.id" label="Infrastructure Component ID"/>-->
          <el-table-column prop="infrastructure.component.name" label="Infrastructure Component Name"/>
          <el-table-column prop="route.name" label="Route name"/>
          <el-table-column prop="http.method.name" label="Method Name"/>
          <!-- TODO: Needs an update in the future about select ids or values -->
          <el-table-column label="Permission Requirement Groups" width="400px">
            <template #default="scope">
              <!-- Ensure structure is properly initialized -->
              <div v-if="!Array.isArray(scope.row.permission.requirement.values)">
                <el-button type="primary" @click="initializeGroups(scope.row)">
                  Initialize permission groups
                </el-button>
              </div>

              <div v-else>
                <el-button type="primary" @click="addGroup(scope.row)" :disabled="checkForExistingGroup(scope.row)">
                  Add new group
                </el-button>
                <div v-for="(group, index) in scope.row.permission.requirement.values" :key="index">
                  <el-select
                      v-model="scope.row.permission.requirement.values[index]"
                      multiple
                      placeholder="Select Permissions"
                  >
                    <!--@change="updatePermissionNames(scope.row, index, group)" -->
                    <el-option
                        v-for="item in permissions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                  </el-select>
                  <el-button type="danger" @click="removeGroup(scope.row, index)">
                    Remove group
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Boundary Lookup Keys" width="200px">
            <template #default="scope">
              <el-select
                  v-model="scope.row.contextBoundary.lookupKeys"
                  multiple
                  placeholder="Select Boundary Lookup Keys"
              >
                <el-option
                    v-for="item in lookupKeys"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>


            </template>
          </el-table-column>
          <!-- TODO: Unsure if we keep this property for to identify properties to classes -->
          <el-table-column prop="model" label="model">
            <template #default="scope">
              <el-input type="textarea" v-model="scope.row.model"/>
            </template>
          </el-table-column>
          <el-table-column prop="JWT.isRequired" label="Is JWT required?">
            <template #default="scope">
              <el-checkbox v-model="scope.row.JWT.isRequired"/>
            </template>
          </el-table-column>
          <el-table-column prop="headerAPIkey.isRequired" label="Is Header-API-Key required?">
            <template #default="scope">
              <el-checkbox v-model="scope.row.headerAPIkey.isRequired"/>
            </template>
          </el-table-column>
          <el-table-column label="Actions">
            <template #default="scope">
              <el-button type="warning" @click="updateAPIRoutes(scope.row)">
                Save
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.searchform {
  display: inline-flex !important;
}
</style>

<i18n>
{
  "en-US": {
  }
}
</i18n>
